module.exports = __webpack_public_path__ + "assets/img/detail-content-img-1-9932f074.jpg";